import { getToken } from '../models/auth';

function setupInterceptors(apiInstance) {
  apiInstance.interceptors.request.use(
    config => {
      const token = getToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  apiInstance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response?.status === 401) {
        window.location.href = '/logout';
      }
      return Promise.reject(error);
    }
  );
}

export default setupInterceptors;

